export default "__VITE_ASSET__DHtCBySF__"